







import { BaseSelect, selectName } from '@/main/components/baseSelect';

import { NAME } from '../constants';

type BaseMapperData = {
	ID: number;
	ZAZNAM_ID: number;
	PNEU_POPIS: string;
	POPIS: string;
};

type RequestedData = {
	id: number | null;
	zaznamId: number | null;
	pneuPopis: string | null;
	popis: string | null;
	isClear: boolean;
	valueStoreKey: string;
};

type Data = {
	storeObject: string;
	emptyObject: RequestedData;
};

export default BaseSelect.extend({
	name: selectName(NAME),
	props: {
		labelKey: { type: String, required: true },
		showLabel: { type: Boolean, default: true },
		popis: { type: String },
		valueStoreKey: { type: String, required: true },
	},
	data(): Data {
		return {
			storeObject: NAME,
			emptyObject: {
				id: null,
				zaznamId: null,
				pneuPopis: null,
				popis: null,
				isClear: true,
				valueStoreKey: this.valueStoreKey,
			},
		};
	},
	computed: {
		popisCmp: {
			get() {
				return this.popis;
			},
			set(val: string) {
				this.$emit('update:popis', val);
			},
		},
	},
	methods: {
		dbToBaseMapper(data: BaseMapperData): RequestedData {
			return {
				id: data.ID,
				zaznamId: data.ZAZNAM_ID,
				pneuPopis: data.PNEU_POPIS,
				popis: data.POPIS,
				isClear: false,
				valueStoreKey: this.valueStoreKey,
			};
		},
	},
});
